import React from 'react';
import { Search, Filter, X, Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Controles de filtro da lista.
 *
 * O antigo select "Grupo" saiu: o grupo virou navegação (pastas dentro da aba).
 * No lugar entrou o "mostrar tudo", que ignora os grupos e lista todos os
 * devices do tipo de uma vez.
 */
const DeviceFilters = ({ filters, onChange, selectedType, showAll = false, onShowAllChange }) => {
  const { t } = useTranslation();

  const handleSearchChange = (e) => {
    onChange({ ...filters, search: e.target.value });
  };

  const handleStatusChange = (e) => {
    onChange({ ...filters, status: e.target.value });
  };

  const clearFilters = () => {
    onChange({ search: '', status: '' });
  };

  const hasActiveFilters = filters.search || filters.status;

  const searchPlaceholder = selectedType?.name
    ? t('managedDevices.filters.searchPlaceholder', { type: selectedType.name.toLowerCase() })
    : t('managedDevices.filters.searchPlaceholderFallback');

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-4">
      <div className="flex items-center gap-2">
        <Filter size={16} className="text-gray-500" />
        <span className="font-medium text-gray-700">{t('managedDevices.filters.label')}</span>
        {hasActiveFilters && (
          <button
            type="button"
            className="ml-auto flex items-center gap-1 text-sm text-theme-primary hover:text-theme-primary/80"
            onClick={clearFilters}
          >
            <X size={14} />
            {t('managedDevices.filters.clearAll')}
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('managedDevices.filters.search')}
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={filters.search}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-theme-primary focus:border-theme-primary"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('managedDevices.filters.status')}
          </label>
          <select
            value={filters.status}
            onChange={handleStatusChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-theme-primary focus:border-theme-primary"
          >
            <option value="">{t('managedDevices.filters.allStatuses')}</option>
            <option value="online">{t('managedDevices.filters.statusOnline')}</option>
            <option value="offline">{t('managedDevices.filters.statusOffline')}</option>
            <option value="error">{t('managedDevices.filters.statusError')}</option>
            <option value="warning">{t('managedDevices.filters.statusWarning')}</option>
            <option value="unknown">{t('managedDevices.filters.statusUnknown')}</option>
          </select>
        </div>

        <div className="flex items-end">
          <label className="flex cursor-pointer select-none items-center gap-2 py-2 text-sm text-gray-700">
            <input
              type="checkbox"
              className="rounded border-gray-300"
              checked={showAll}
              onChange={(e) => onShowAllChange(e.target.checked)}
            />
            <Eye size={16} className="text-gray-500" />
            {t('managedDevices.groups.showAll')}
          </label>
        </div>
      </div>
    </div>
  );
};

export default DeviceFilters;
